module.exports = __webpack_public_path__ + "static/media/edyoda.5b867158.png";